import { useMemo } from 'react';
import { s } from './NPL.styles';
import { ReportFormatNumber } from '../../../../func/Function';
import { NplCalculation } from '../../../../utils/nplAnalysis';

interface SeniorityDetailsProps {
  seniorityDetails: ReturnType<typeof NplCalculation.prototype.getSeniorInfo>;
}

const ItemRow = ({
  label,
  content,
}: {
  label: React.ReactNode;
  content: React.ReactNode;
}) => (
  <s.Item>
    <s.ItemLabel>{label}</s.ItemLabel>
    <s.ItemContent>{content}</s.ItemContent>
  </s.Item>
);

const SeniorityDetails = ({ seniorityDetails }: SeniorityDetailsProps) => {
  const rows = useMemo(
    () => [
      {
        label: '경매비용 (가지급금)',
        content: ReportFormatNumber(seniorityDetails.row2_2),
      },
      { label: '타신청경매비용', content: '-' },
      { label: '당해세', content: seniorityDetails.row2_1 ?? '-' },
      { label: '임금채권', content: seniorityDetails.row1_2 ?? '-' },
      {
        label: '최우선변제',
        content: ReportFormatNumber(seniorityDetails.row5),
      },
      {
        label: '선순위 조세',
        content: ReportFormatNumber(seniorityDetails.row4),
      },
      {
        label: '선순위 근저당수',
        content: ReportFormatNumber(seniorityDetails.row3_2),
      },
      {
        label: '선순위 임대차',
        content: ReportFormatNumber(seniorityDetails.row3_1),
      },
      { label: '채권관리 수수료', content: '-' },
    ],
    [seniorityDetails],
  );

  return (
    <s.Div>
      <s.Title>선순위내역</s.Title>

      <div>
        <s.GrayBox>
          <s.Item style={{ padding: '6px 0px' }}>
            <s.ItemLabel>매입채권순위</s.ItemLabel>
            <s.ItemContent style={{ color: '#008AFF' }}>
              {seniorityDetails.row1_1 ?? '-'}
            </s.ItemContent>
          </s.Item>
        </s.GrayBox>
        {rows.map((r, i) => (
          <ItemRow key={i} label={r.label} content={r.content} />
        ))}
      </div>
      <div>
        <s.BlueBox>
          <s.LeftCell style={{ color: '#222222' }}>합계금액</s.LeftCell>
          <s.RightCell style={{ color: '#008AFF', fontWeight: '700' }}>
            {ReportFormatNumber(seniorityDetails.row6)}
          </s.RightCell>
        </s.BlueBox>
        <s.Description style={{ marginTop: '8px' }}>
          <img
            src="/assets/images/icon/info_16.svg"
            alt=""
            style={{ width: 16 }}
          />
          <span>선순위내역은 상세분석이 요구됩니다.</span>
        </s.Description>
      </div>
    </s.Div>
  );
};

export default SeniorityDetails;
